export { default as StudioHotspotImage, StudioHotspotImageV2 } from './StudioHotspotImage';
